import React, { memo } from 'react'
import styles from './index.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, AppState } from '@/store/types'
import { UserRelationsModel } from '@/services/apis/user/model'
import cls from 'classnames'
import { Avatar } from 'antd'
import checkedImg from '@/assets/images/checked.svg'
import { useTranslation } from 'react-i18next'
import { WorkspaceMemberModel } from '@/services/apis/user/model'

import { useNavigate } from 'react-router-dom'

import cacheUtil, { CACHE_WORKSPACE_KEY } from '@/utils/cache'

import { setIsLocalBackup } from '@/store/user'
const LogoContent = memo(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const walletList = useSelector<AppState, UserRelationsModel[]>(state => state.user.userRelations)
  const workspaceMember = useSelector<AppState, WorkspaceMemberModel>(
    state => state.user.workspaceMember
  )

  const changeWallet = (item: UserRelationsModel) => {
    if (!item.isAuthorizedDevice) return
    // navigatePage(PageAlias.wallet, `?wkey=${item.workspaceKey}`)
    cacheUtil.set(CACHE_WORKSPACE_KEY, item.workspaceKey)
    // 重制备份状态
    dispatch(setIsLocalBackup(false))
    navigate(`/wallet?wkey=${item.workspaceKey}`)
  }

  return (
    <div className={styles.content}>
      {walletList?.map(item => {
        return (
          <div
            key={item?.workspaceKey}
            className={cls({
              [styles.disabled]: !item.isAuthorizedDevice,
              [styles.container]: true,
            })}
            onClick={() => changeWallet(item)}
            style={{ height: !item.isAuthorizedDevice ? '50px' : '40px' }}
          >
            <div className={styles.left}>
              <Avatar
                src={item.workspacePortrait}
                size={30}
                className={styles.img}
                shape="square"
              />
              <div
                style={{
                  maxWidth: '180px',
                  lineHeight: '14px',
                  marginTop: !item.isAuthorizedDevice ? '10px' : '0px',
                }}
              >
                <div>{item.workspaceName}</div>
                {!item.isAuthorizedDevice && (
                  <div style={{ fontSize: '12px' }}>{t('common.disableMsg')}</div>
                )}
              </div>
            </div>
            {item.workspaceKey === workspaceMember.workspaceKey && (
              <div className={styles.right}>
                <img width="20" src={checkedImg} alt=""></img>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
})

export default LogoContent
